export default {
    Docusign: "Docusign",
    Maintenance: "Maintenance",
    ContactDetails: "ContactDetails"
}